import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Indicates that no payment methods were found while attempting to make a payment. This can occur for a number of reasons:`}</p>
    <ul>
      <li parentName="ul">{`No payment methods were found in the client session and/or the SDK is not initialized.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`allowedPaymentMethods`}</inlineCode>{` filtered out all the payment methods.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      